import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import reportWebVitals from './reportWebVitals';

// const root = ReactDOM.createRoot(document.getElementById("root"));
let root: any;
const rootElement = document.getElementById('root');
if (rootElement)
  root = ReactDOM.createRoot(rootElement);


root.render(
  // <React.StrictMode>
  //   <App />
  // </React.StrictMode>
  <>
    <App />
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
